module.exports = __webpack_public_path__ + "img/manecilla.9310244a.svg";